import axios, { AxiosInstance } from "axios";
import { IncomingHttpHeaders } from "http";

export class Http {
  static async axios(): Promise<AxiosInstance> {
    const headers: IncomingHttpHeaders = {
      "content-type": "application/json",
    };

    headers.app = "webSite";

    const instance = axios.create({
      headers,
      timeout: 120 * 1250,
      baseURL: process.env.REACT_APP_API_URL,
    });

    instance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        const { response } = error || null;
        if (!response) {
          return Promise.reject(error);
        }

        if (!response) {
          window.alert(`Nenhuma resposta, ${{ ...error }}`);
          return Promise.reject(error);
        } else if (
          response &&
          (response.status === 502 || response.status === 502.3)
        ) {
          window.alert(
            `Ops... ${response.status} Conexão instável, Tente novamente`
          );
          return Promise.reject(error);
        } else if (response && response.status === 500) {
          window.alert(
            `Ops... ${response.status} Conexão instável, Tente novamente`
          );
          return Promise.reject(error);
        } else if (!response || !error) {
          window.alert("Conexão instável, Tente novamente");
          return Promise.reject(error);
        } else if (response.status === 403) {
          window.alert("Você não está autorizado á realizar esta ação...");
        }

        const { data } = response || null;
        if (!data) {
          return Promise.reject(response);
        }

        console.log(data);

        const result = {
          ...error,
          response: {
            ...response,
            data: {
              ...data,
            },
          },
        };
        return Promise.reject(result);
      }
    );

    return instance;
    // TODO: Add caching to not create every time, only if key is added/missing
  }
}
